import { observer } from 'mobx-react';

import MetricGradeNumericRangeSelect from '@/catalog/components/CatalogSidebar/CatalogFilters/MetricGradeNumericRangeSelect/MetricGradeNumericRangeSelect';
import Filters from '@/catalog/entity/Filters';
import { FilterInputMeta } from '@/catalog/types/filterInputMeta';
import { FilterValue } from '@/catalog/types/filterValue';
import FormGroup from '@/common/components/inputs/FormGroup/FormGroup';
import FormLabel from '@/common/components/inputs/FormGroup/FormLabel/FormLabel';
import { OPTICAL_METRIC_MARKS } from '@/metric/constants/marks';

const DEFAULT_MAX_VALUE = 1;

export interface GradeFilterProps {
  filters: Filters;
  filterInputMeta: FilterInputMeta;
  isFilterInputMetaEmpty: boolean;
  areFiltersInputMetaActive: boolean;
  marks?: string[];
}

function GradeFilter(props: GradeFilterProps) {
  const {
    filters,
    filterInputMeta,
    isFilterInputMetaEmpty,
    areFiltersInputMetaActive,
    marks = OPTICAL_METRIC_MARKS,
  } = props;

  const range = filterInputMeta.range as Nullable<number[]>;
  const sliderMarks = { ...[...marks, ''] };
  const maxValue = range ? range[range.length - 1] : DEFAULT_MAX_VALUE;
  const value = filterInputMeta.getter?.(filters) as FilterValue;

  return (
    <FormGroup key={filterInputMeta.id}>
      {filterInputMeta.showTitle && (
        <FormLabel
          isFilterInputMetaEmpty={isFilterInputMetaEmpty}
          areFiltersInputMetaActive={areFiltersInputMetaActive}
        >
          {filterInputMeta.name}
        </FormLabel>
      )}

      <MetricGradeNumericRangeSelect
        onChange={(value: FilterValue) => filterInputMeta.setter?.(value, filters)}
        from={value.from}
        to={value.to}
        min={0}
        max={maxValue}
        marks={sliderMarks}
        step={filterInputMeta.step}
      />
    </FormGroup>
  );
}

export default observer(GradeFilter);
